export default "__VITE_ASSET__ByuqJ3Im__ 600w";